export default __webpack_public_path__ + "static/media/appstore-btn.dfe1227e.png";